import { render } from "./WordComponent.vue?vue&type=template&id=71152fc4&scoped=true&ts=true"
import script from "./WordComponent.vue?vue&type=script&lang=ts"
export * from "./WordComponent.vue?vue&type=script&lang=ts"

import "./WordComponent.vue?vue&type=style&index=0&id=71152fc4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71152fc4"]])

export default __exports__